class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleOptionValueChange.bind(this)
    );
  }

  handleOptionValueChange() {
    
    const url = `${window.location.href}&section_id=${this.sectionId}`;
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector(`slider-component`);
        
        if (newSection) {
          const currentSection = document.querySelector(`#Related-products slider-component`);
          currentSection.innerHTML = newSection.innerHTML;
        }
      })
      .catch(error => {
        console.error('Error fetching section HTML:', error);
      });
  }
}

customElements.define('related-products', RelatedProducts);